import { render } from "./CustomBadge.vue?vue&type=template&id=fb62fac0&scoped=true"
import script from "./CustomBadge.vue?vue&type=script&lang=js"
export * from "./CustomBadge.vue?vue&type=script&lang=js"

import "./CustomBadge.vue?vue&type=style&index=0&id=fb62fac0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb62fac0"]])

export default __exports__